<div nz-row class="d-flex align-i-c">
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="9" nzLg="9" nzXl="12">
        <h1 class="page-title-text">Tags</h1>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="15" nzLg="15" nzXl="12" class="mt-mobile">
        <div class="d-flex justify-content-end">
            <div class="mr-1 select-box-width">
                <nz-form-control nzErrorTip="Please input your username!">
                    <nz-input-group nzPrefixIcon="search" class="search-input">
                        <input [(ngModel)]="searchText" (keyup)="searchTag($event)" nz-input
                            placeholder="Search by tag name" />
                    </nz-input-group>
                </nz-form-control>
            </div>
            <div class="NewDropDown" *ngIf="canAddTag">
                <a nz-dropdown [nzDropdownMenu]="menu" class="addButton medium-btn">
                    New
                    <span nz-icon nzType="down"></span>
                </a>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                        <li nz-menu-item (click)="VisibleTagGroup(null)">Tag Group</li>
                        <li nz-menu-item (click)="VisibleTag(null, null)">Tag</li>
                    </ul>
                </nz-dropdown-menu>
            </div>
        </div>
    </div>
</div>
<div nz-row>
    <div nz-col nzSpan="24" class="section-top-padding">
        <nz-table #nzTable [nzData]="tagGroupData" nzTableLayout="fixed" [nzPageSize]="pageRecord"
            [nzShowPagination]="totalRecords > 100" [nzOuterBordered]="true" [nzFrontPagination]="false" [nzHideOnSinglePage]="true"
            [(nzPageIndex)]="pageNumber" [nzTotal]="totalRecords" (nzPageIndexChange)="onQueryParamsChange($event)"
            [nzScroll]="tagGroupData.length > 0 ?  {y: 'calc(100vh - 21em)' } : {}" class="tags-table">
            <thead>
                <tr>
                    <ng-container *ngFor="let col of cols;let i=index">
                        <th *ngIf="col.width && col.title != 'Action'" nz-resizable nzBounds="window"
                            [nzColumnKey]="col.sortTitle" nzPreview [nzMinWidth]="50" [nzMaxWidth]="500"
                            [nzWidth]="col.width" [(nzSortOrder)]="col.sortDir"
                            (nzSortOrderChange)="sort(i, col.sortTitle || '', $event)"
                            (nzResizeEnd)="onResize($event, col.title)" [nzShowSort]="col.sortTitle ? true : false"
                            
                            [nzDisabled]="col.title == '' ? true : false">
                            {{ col.title }}
                            <nz-resize-handle nzDirection="right">
                                <div class="resize-trigger"></div>
                            </nz-resize-handle>
                        </th>
                        <th *ngIf="col.title == 'Action' && (canEditTag || canDeleteTag)" [nzWidth]="col.width"
                            >
                            {{ col.title }}
                        </th>
                    </ng-container>
                </tr>
            </thead>
            <tbody *ngIf="!isDataLoaded" cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListSortPredicate]="sortPredicateForDisableItem(tagGroupData)">
                <ng-container *ngFor="let tagGroupdata of tagGroupData; let i= index">
                    <tr (dblclick)="canEditTag && !tagGroupdata.isDefault ? VisibleTagGroup(tagGroupdata) : null" cdkDrag [cdkDragDisabled]="tagGroupdata.isDefault">
                        <td [nzExpand]="expandSet.has(tagGroupdata.id) && tagGroupdata.tags.length > 0 && !tagGroupdata.isDefault"
                            [nzShowExpand]="tagGroupdata.tags.length > 0 && !tagGroupdata.isDefault"
                            (nzExpandChange)="onExpandChange(tagGroupdata.id, $event)">
                            <span class="sorterContainer">
                                <span *ngIf="tagGroupdata.tags.length > 0 && !tagGroupdata.isDefault" class="sorter mt-5" nz-icon nzType="drag" nzTheme="outline" ></span>
                            </span>
                        </td>
                        <td>
                            <div class="d-flex"> <span [ngStyle]="{'background-color': tagGroupdata.color }"
                                    class="tagGroupColor"></span> {{ tagGroupdata.name }} </div>
                        </td>
                        <td><a
                                (click)="tagGroupdata.count != null ? navigateToActivity(tagGroupdata) : null"> {{
                                tagGroupdata.count != null ? tagGroupdata.count : 0}}
                                Transactions</a>
                        </td>
                        <td *ngIf="canEditTag || canDeleteTag">
                            <img *ngIf="canEditTag && !tagGroupdata.isDefault" src="/assets/images/edit.png "
                                class="mr-1 cursor" (click)="VisibleTagGroup(tagGroupdata)" />
                            <img *ngIf="canDeleteTag && !tagGroupdata.isDefault" class="cursor"
                                src="/assets/images/delete.png "
                                (click)="showDeleteConfirm(tagGroupdata,tagGroupdata)" />
                        </td>
                    </tr>
                    <tr
                        [nzExpand]="expandSet.has(tagGroupdata.id) && tagGroupdata.tags.length > 0 && !tagGroupdata.isDefault">
                        <td [colSpan]="4">
                        <nz-table #nzTagTable [nzData]="tagGroupdata.tags" nzTableLayout="fixed"
                            [nzShowPagination]="false" class="childtable" [nzFrontPagination]="false">
            <tbody>
                <ng-container *ngFor="let data of nzTagTable.data">
                    <tr (dblclick)="canEditTag ? VisibleTag(tagGroupdata, data) : null">
                        <td class="w-100"></td>
                        <td class="w-800" nzEllipsis nz-tooltip
                            [nzTooltipTitle]="(tagGroupdata.name.length + data.name.length) > 40 ? tagGroupdata.name + ': ' +data.name : ''">
                            <span class="tag-list">
                                <span [ngStyle]="{'background-color': tagGroupdata.color }"
                                    style="width: 10px;height:30px"></span>&nbsp;{{tagGroupdata.name}}:&nbsp; <b>{{
                                    data.name }}</b>
                            </span>
                        </td>
                        <td class="w-300"><a class="pl-30" (click)="data.count > 0 ? navigateToActivity(data) : null"> {{ data.count ? data.count :
                                0 }} Transactions </a></td>
                        <td class="w-150" *ngIf="canEditTag || canDeleteTag">
                            <img *ngIf="canEditTag && !tagGroupdata.isDefault" src="/assets/images/edit.png "
                                class="mr-1 cursor pl-30" (click)="VisibleTag(tagGroupdata, data)" />
                            <img *ngIf="canDeleteTag && !tagGroupdata.isDefault" class="cursor"
                                src="/assets/images/delete.png " (click)="showDeleteConfirm(tagGroupdata,data)" />
                        </td>
                        
                    </tr>
                </ng-container>
            </tbody>
        </nz-table>
    </td>   
        </tr>
        </ng-container>
        </tbody>
        <ng-container *ngIf="isDataLoaded">
            <tbody *ngIf="isDataLoaded">
                <tr *ngFor="let i of [].constructor(50)">
                    <ng-container *ngFor="let i of [].constructor(canEditTag || canDeleteTag ? 4 : 3)">
                        <td [nzAlign]="'left'" class="loading">
                            <div class="bar"></div>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </ng-container>
        </nz-table>
    </div>
</div>
<!--tag group modal-->
<nz-modal [(nzVisible)]="isVisibleTagGroup" nzClassName="add-tag-modal-box" [nzTitle]="groupTitle" [nzFooter]="null"
    (nzOnCancel)="handleCancel()" [nzMaskClosable]="false" class="modal-padding-none" *ngIf="!isFromPayments">
    <ng-container *nzModalContent>
        <div cdkScrollable>
            <form [formGroup]="_fS.tagsGroupForm" class="edit-tag-group">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div nz-col nzXs="24" nzSm="20" nzMd="20" [nzLg]="isTagGroupAdded ? '24' : '20'"
                        [nzXl]="isTagGroupAdded ? '24' : '20'">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="tagGroupNameError">
                                <label class="label-text required">Tag group name</label>
                                <nz-input-group [nzPrefix]="isTagGroupAdded ? suffixIconSearch: ''">
                                    <input [ngClass]="isTagGroupAdded ? 'savedClass' : ''" class="input-group" nz-input
                                        formControlName="tagGroupName" minlength="2" maxlength="40"
                                        placeholder="Enter Group Name" [readonly]="isTagGroupAdded" />
                                </nz-input-group>
                                <ng-template #suffixIconSearch>
                                    <div class="rountTagGroupColor"></div>
                                </ng-template>
                                <ng-template #tagGroupNameError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter group name
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Group name must contain at least
                                        2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="4" nzMd="4" nzLg="4" nzXl="4" *ngIf="!isTagGroupAdded">
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text required">Color</label>
                                <nz-input-group [nzSuffix]="suffixIconArrow">
                                    <div class="color-picker">
                                        <div class="summary-info" (click)="toggleColors()">
                                            <div class="circle m-0" [ngStyle]="{'background': color}"></div>
                                        </div>
                                        <div class="opened" *ngIf="show">
                                            <div class="colors">
                                                <div (click)="changeColor(paint)" *ngFor="let paint of defaultColors"
                                                    [class]="'circle selected' + ' ' + paint.class"
                                                    [ngStyle]="{'background': paint.color}"
                                                    [ngClass]="paint.color == color ? 'selectedColor': ''"></div>
                                            </div>
                                            <div class="hex-code">
                                                <p>Hex Code</p>
                                                <div class="g-input">
                                                    <input type="text" maxlength="7" [value]="color"
                                                        (keyup)="changeColorManual(paintInput.value)" #paintInput
                                                        (keydown.enter)="toggleColors()" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </nz-input-group>
                                <ng-template #suffixIconArrow>
                                    <span nz-icon nzType="down" nzTheme="outline" (click)="toggleColors()"></span>
                                </ng-template>
                                <p *ngIf="color == ''" class="invalidtagname">Please select group color</p>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <button nz-button nzType="primary" (click)="addTagGroup()" [nzLoading]="isLoadingTag"
                    *ngIf="!isTagGroupAdded">
                    Save
                </button>
            </form>

            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="padding-add">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <label class="label-text">Add Tags to this group</label>
                    <div class="d-flex mb-2">
                        <input [disabled]="!isEnableButton" class="input-group mr-1" nz-input [(ngModel)]="tagname"
                            maxlength="40" (keyup.enter)="addTagstoGroup()"/>
                        <p *ngIf="invalidtagname" class="invalidtagname">Please enter tag name</p>
                        <button nz-button nzType="primary" (click)="addTagstoGroup()" [disabled]="!isEnableButton"
                            [nzLoading]="isLoadingTagUpdate">
                            Add
                        </button>
                    </div>

                </div>
            </div>
            <div class="d-flex flex-wrap">
                <div *ngFor="let tag of tags; let i=index;" class="m-1">
                    <span class="tag-list"><span class="tagsListColor"></span>
                        &nbsp; {{_fS.tagsGroupForm.get('tagGroupName').value + ': '}}&nbsp; <b>{{tag.name}}</b>
                        <span nz-icon nzType="close" nzTheme="outline" (click)="removeTag(i)"
                            class="cursor"></span></span>
                </div>
            </div>
        </div>
    </ng-container>
</nz-modal>
<!--if is from payment screen-->
<nz-drawer [nzMaskClosable]="false" [nzVisible]="isVisibleTagGroup" nzPlacement="right" [nzTitle]="groupTitle"
    (nzOnClose)="handleCancel()" [nzWidth]="500" [nzFooter]="tagGroupfooterTpl" *ngIf="isFromPayments == true">
    <ng-container *nzDrawerContent>
        <div cdkScrollable>
            <form [formGroup]="_fS.tagsGroupForm" class="edit-tag-group">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div nz-col nzXs="24" nzSm="20" nzMd="20" [nzLg]="isTagGroupAdded ? '24' : '20'"
                        [nzXl]="isTagGroupAdded ? '24' : '20'">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="tagGroupNameError">
                                <label class="label-text required">Tag group name</label>
                                <nz-input-group [nzPrefix]="isTagGroupAdded ? suffixIconSearch: ''">
                                    <input [ngClass]="isTagGroupAdded ? 'savedClass' : ''" class="input-group" nz-input
                                        formControlName="tagGroupName" minlength="2" maxlength="40"
                                        placeholder="Enter Group Name" [readonly]="isTagGroupAdded" />
                                </nz-input-group>
                                <ng-template #suffixIconSearch>
                                    <div class="rountTagGroupColor"></div>
                                </ng-template>
                                <ng-template #tagGroupNameError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter group name
                                    </ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Group name must contain at least
                                        2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="4" nzMd="4" nzLg="4" nzXl="4" *ngIf="!isTagGroupAdded">
                        <nz-form-item>
                            <nz-form-control>
                                <label class="label-text required">Color</label>
                                <nz-input-group [nzSuffix]="suffixIconArrow">
                                    <div class="color-picker">
                                        <div class="summary-info" (click)="toggleColors()">
                                            <div class="circle m-0" [ngStyle]="{'background': color}"></div>
                                        </div>
                                        <div class="opened" *ngIf="show">
                                            <div class="colors">
                                                <div (click)="changeColor(paint)" *ngFor="let paint of defaultColors"
                                                    [class]="'circle selected' + ' ' + paint.class"
                                                    [ngStyle]="{'background': paint.color}"
                                                    [ngClass]="paint.color == color ? 'selectedColor': ''"></div>
                                            </div>
                                            <div class="hex-code">
                                                <p>Hex Code</p>
                                                <div class="g-input">
                                                    <input type="text" maxlength="7" [value]="color"
                                                        (keyup)="changeColorManual(paintInput.value)" #paintInput
                                                        (keydown.enter)="toggleColors()" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </nz-input-group>
                                <ng-template #suffixIconArrow>
                                    <span nz-icon nzType="down" nzTheme="outline" (click)="toggleColors()"></span>
                                </ng-template>
                                <p *ngIf="color == ''" class="invalidtagname">Please select group color</p>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
                <button nz-button nzType="primary" (click)="addTagGroup()" [nzLoading]="isLoadingTag"
                    *ngIf="!isTagGroupAdded">
                    Save
                </button>
            </form>
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="padding-add">
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <label class="label-text">Add Tags to this group</label>
                    <div class="d-flex mb-2">
                        <input [disabled]="!isEnableButton" class="input-group mr-1" nz-input [(ngModel)]="tagname"
                            maxlength="40" />
                        <p *ngIf="invalidtagname" class="invalidtagname">Please enter tag name</p>
                        <button nz-button nzType="primary" (click)="addTagstoGroup()" [disabled]="!isEnableButton"
                            [nzLoading]="isLoadingTagUpdate">
                            Add
                        </button>
                    </div>

                </div>
            </div>
            <div class="d-flex flex-wrap">
                <div *ngFor="let tag of tags; let i=index;" class="m-1">
                    <span class="tag-list"><span class="tagsListColor"></span>
                        &nbsp; {{_fS.tagsGroupForm.get('tagGroupName').value + ': '}}&nbsp; <b>{{tag.name}}</b>
                        <span nz-icon nzType="close" nzTheme="outline" (click)="removeTag(i)"
                            class="cursor"></span></span>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #tagGroupfooterTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="primary" (click)="isVisibleTagGroup = false" class="medium-btn width-100 mr-1">
                Done
            </button>
        </div>
    </ng-template>
</nz-drawer>
<!--tag modal-->
<nz-modal [(nzVisible)]="isVisibleTag" [nzTitle]="tagTitle" [nzFooter]="tagfooterTpl"
    (nzOnCancel)="handleCancelisVisibleTag()" [nzMaskClosable]="false" *ngIf="!isFromPayments">
    <ng-container *nzModalContent>
        <!-- <form [formGroup]="_fS.tagForm">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 20, lg: 20 }">
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="tagNameError">
                            <label class="label-text required">Tag name</label>
                            <input class="input-group" nz-input formControlName="tagName" minlength="2" maxlength="40"
                                placeholder="Enter Tag Name" />
                            <ng-template #tagNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter tag name
                                </ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Tag name must contain at least 2
                                    characters
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="tagGroupError">
                            <label class="label-text required">Tag group name</label>
                            <nz-select nzShowSearch nzPlaceHolder="Select Tag Group" [nzSize]="'default'"
                                formControlName="tagGroup" (ngModelChange)="checkTagGroupData($event)"
                                [nzCustomTemplate]="defaultTemplate" [nzSelectOnTab]="true" >
                                <ng-container *ngIf="!_cS.isLoadingTags">
                                    <nz-option *ngFor="let option of listOfGroups" nzCustomContent
                                        [nzValue]="option._id" [nzLabel]="option.Name">
                                        <span class="d-flex"><span class="rountTagGroupColor rount-tag"
                                                [ngStyle]="{'background-color':option.Color}"></span><span>{{option.Name}}</span></span>
                                    </nz-option>
                                </ng-container>
                                <nz-option *ngIf="_cS.isLoadingTags" nzDisabled nzCustomContent>
                                    <span nz-icon nzType="loading" class="loading-icon"></span>
                                    Loading Data...
                                </nz-option>
                            </nz-select>
                            <ng-template #defaultTemplate let-selected>
                                <span class="d-flex"><span class="rountTagGroupColor rount-tag mt-13"
                                        [ngStyle]="{'background-color':selectedTagGroup.Color}"></span><span>{{selected.nzLabel}}</span></span>
                            </ng-template>
                            <ng-template #tagGroupError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select tag group
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </form> -->
        <app-tag-form [selectedTagData]="selectedTagData" [selectedTagGroup]="selectedTagGroup"></app-tag-form>
    </ng-container>
    <ng-template #tagfooterTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancelisVisibleTag()"
                class="default-btn width-100">
                Cancel
            </button>
            <button nz-button nzType="primary" (click)="handleOkisVisibleTag()" [nzLoading]="isLoadingTag"
                class="medium-btn small-btn width-100 ">
                {{ selectedTagData != null ? "Update" : "Add" }}
            </button>
        </div>
    </ng-template>
</nz-modal>
<!--if is from payment screen-->
<nz-drawer [nzMaskClosable]="false" [nzVisible]="isVisibleTag" nzPlacement="right" [nzTitle]="tagTitle"
    [nzFooter]="tagfooterTpl" (nzOnClose)="handleCancelisVisibleTag()" [nzWidth]="500" *ngIf="isFromPayments == true">
    <ng-container *nzDrawerContent>
        <app-tag-form [selectedTagData]="selectedTagData" [selectedTagGroup]="selectedTagGroup"></app-tag-form>
        <!-- <form [formGroup]="_fS.tagForm">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 20, lg: 20 }">
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="tagNameError">
                            <label class="label-text required">Tag name</label>
                            <input class="input-group" nz-input formControlName="tagName" minlength="2" maxlength="20"
                                placeholder="Enter Tag Name" />
                            <ng-template #tagNameError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please enter tag name
                                </ng-container>
                                <ng-container *ngIf="control.hasError('minlength')">Tag name must contain at least 2
                                    characters
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control [nzErrorTip]="tagGroupError">
                            <label class="label-text required">Tag group name</label>
                            <nz-select nzShowSearch nzPlaceHolder="Select Tag Group" [nzSize]="'default'"
                                formControlName="tagGroup" (ngModelChange)="checkTagGroupData($event)"
                                [nzCustomTemplate]="defaultTemplate" [nzSelectOnTab]="true" >
                                <ng-container *ngIf="!_cS.isLoadingTags">
                                    <nz-option *ngFor="let option of listOfGroups" nzCustomContent
                                        [nzValue]="option._id" [nzLabel]="option.Name">
                                        <span class="d-flex"><span class="rountTagGroupColor rount-tag"
                                                [ngStyle]="{'background-color':option.Color}"></span><span>{{option.Name}}</span></span>
                                    </nz-option>
                                    <nz-option *ngIf="_cS.isLoadingTags" nzDisabled nzCustomContent>
                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                        Loading Data...
                                    </nz-option>
                                </ng-container>
                            </nz-select>
                            <ng-template #defaultTemplate let-selected>
                                <span class="d-flex"><span class="rountTagGroupColor rount-tag mt-13"
                                        [ngStyle]="{'background-color':selectedTagGroup.Color}"></span><span>{{selected.nzLabel}}</span></span>
                            </ng-template>
                            <ng-template #tagGroupError let-control>
                                <ng-container *ngIf="control.hasError('required')">Please select tag group
                                </ng-container>
                            </ng-template>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </form> -->
    </ng-container>
    <ng-template #tagfooterTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancelisVisibleTag()"
                class="default-btn width-100 mr-1">
                Cancel
            </button>
            <button nz-button nzType="primary" (click)="handleOkisVisibleTag()" [nzLoading]="isLoadingTag"
                class="medium-btn small-btn width-100 ">
                {{ selectedTagData != null ? "Update" : "Add" }}
            </button>
        </div>
    </ng-template>
</nz-drawer>

<!--delete tag or tag group-->
<nz-modal [(nzVisible)]="deleteConfirmVisible" nzCentered [nzMaskClosable]="false" (nzOnCancel)="handleCancelDelete()">
    <div class="confirm-modal">
        <ng-container *nzModalContent class="cc">
            <div class="close-icon center">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
            <h4 class="confirm-modal-title center Font-Medium">Are You Sure?</h4>
            <p class="confirm-modal-sub-title center Font-Regular">Once
                <b>{{selectedData.name}}</b> is deleted, it cannot be recovered.
            </p>
            <p *ngIf="selectedData.tagGroupColor != null">Deleting a group will delete all tags under that group</p>
        </ng-container>
        <div *nzModalFooter class="center border-none d-flex footer-btn">
            <button nz-button nzType="default" (click)="handleCancelDelete()"
                class="default-btn width-100 ">Cancel</button>
            <button nz-button nzType="primary" (click)="deleteData()" [nzLoading]="isDeletingTag"
                class=" medium-btn delete-btn width-100">Delete</button>
        </div>
    </div>
</nz-modal>
